import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

// Service worker temporarily disabled to fix fetch issues
// Clear any existing service workers first
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    console.log('Found', registrations.length, 'service worker registrations to clear');
    for(let registration of registrations) {
      console.log('Unregistering service worker:', registration.scope);
      registration.unregister();
    }
  });
}

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js', {
//       scope: '/'
//     })
//       .then((registration) => {
//         // Service worker registered successfully
//       })
//       .catch((registrationError) => {
//         // Try alternative registration paths
//         navigator.serviceWorker.register('./service-worker.js', {
//           scope: './'
//         })
//           .then((registration) => {
//             // Service worker registered with alternative path
//           })
//           .catch((altError) => {
//             // Alternative SW registration also failed
//           });
//       });
//   });
// }

const root = createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);